<template>
    <div class="main-container">
        <div class="container__alert">
            <transition name="alert--animation">
                <div class="alert alert--error alert__errorConnexion" v-if="errorModal">
                    <div class="alert__header">
                        <div class="alert__title">
                            <p>{{translationArray.error_connection}}</p>
                        </div>
                        <hr>
                    </div>

                    <div class="alert__body">
                        <div class="alert__image">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.340562 19.6125C-0.425702 18.9151 0.340562 17.8689 0.340562 17.8689L8.3095 9.88624L0.512983 2.00191C0.512983 2.00191 -0.360283 0.994184 0.512983 0.258302C1.20265 -0.322869 2.06476 0.258287 2.06476 0.258287L9.99612 8.19672L17.7551 0.43265C17.7551 0.43265 18.7896 -0.43915 19.6517 0.43265C20.3414 1.13006 19.6517 2.00191 19.6517 2.00191L11.6341 9.76105L19.6517 17.8689C19.6517 17.8689 20.4354 18.7407 19.6517 19.6125C18.868 20.4843 17.7551 19.6125 17.7551 19.6125L9.8237 11.5919L1.89235 19.6125C1.89235 19.6125 1.10683 20.31 0.340562 19.6125Z" fill="white" fill-opacity="0.9"/>
                                </svg>
                        </div>
                        <div class="alert__description">
                            <p>{{translationArray.object_not_allowed}}<a href="#"> help.senzu.app/login</a></p>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <header class="headerBlue">
            <svg class="waves" width="455" height="455" viewBox="0 0 455 455" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="227.949" cy="227.949" r="124.244" stroke="#3CB5A8"/>
                <circle cx="227.949" cy="227.948" r="173.603" stroke="#3CB5A8" stroke-opacity="0.4"/>
                <circle cx="227.5" cy="227.5" r="227" stroke="#3CB5A8" stroke-opacity="0.1"/>
            </svg>
            <a @click="historyBack()" class="btnBack">
                <span class="btnBack__svg">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="arrow_back_24px">
                    <path id="icon/navigation/arrow_back_24px" d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z" fill="#3CB5A8"/>
                    </g>
                    </svg>
                </span>
            </a>
            <div class="containerTitle">
                <h1>{{translationArray.connection}}</h1>
                <p><span>{{translationArray.on}}</span><span>{{nameClient}}</span></p>
            </div>

            <div class="containerPartner">
                <div class="partnerBox partnerBox__Left" v-if="!isSenzuApp">
                    <img v-if="!hasImageClient" src="../../static/img/logo.png" :alt="'image_' + nameClient">
                    <img v-if="hasImageClient" :src="urlImageClient" :alt="'image' + nameClient">
                </div>
                <div class="partnerSeparation" v-if="!isSenzuApp">
                    <svg width="34" height="54" viewBox="0 0 34 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M33.0607 13.0607C33.6464 12.4749 33.6464 11.5251 33.0607 10.9393L23.5147 1.3934C22.9289 0.807611 21.9792 0.807611 21.3934 1.3934C20.8076 1.97919 20.8076 2.92893 21.3934 3.51472L29.8787 12L21.3934 20.4853C20.8076 21.0711 20.8076 22.0208 21.3934 22.6066C21.9792 23.1924 22.9289 23.1924 23.5147 22.6066L33.0607 13.0607ZM1 13.5H32V10.5H1V13.5Z" fill="#EEEEEE"/>
                        <path d="M0.939339 40.9393C0.353554 41.5251 0.353554 42.4749 0.939339 43.0607L10.4853 52.6066C11.0711 53.1924 12.0208 53.1924 12.6066 52.6066C13.1924 52.0208 13.1924 51.0711 12.6066 50.4853L4.12132 42L12.6066 33.5147C13.1924 32.9289 13.1924 31.9792 12.6066 31.3934C12.0208 30.8076 11.0711 30.8076 10.4853 31.3934L0.939339 40.9393ZM33 40.5H2V43.5H33V40.5Z" fill="#EEEEEE"/>
                    </svg>                    
                </div>
                <div class=" partnerBox partnerBox__Right">
                    <img src="../../static/img/senzu.png" alt="">
                </div>  
            </div>
            <div class="containerDescription">
                <p>{{translationArray.scan_qr_object}}</p>
            </div>
        </header>
        <section class="bodyBlue">
            <div v-bind:class="{'qr-container': qrActivated}">
                <div id="reader" style="width: 100%"></div>
            </div>
            <select v-if="!hasAvailableCamera" v-model="selectCamera">
                <option v-for="camera in cameras" :value="camera.deviceId" :key="camera.deviceId">
                    {{ camera.label }}
                </option>
            </select>
            <div class="submit" style="width: 100%" type="submit" @click="activateQr()">{{valueBtn}}</div>
        </section>
        <footer>
        </footer>
    </div>
</template>

<script>
import {translate} from '../../static/js/translate';

export default {
  name: 'QrCode',
  mounted() {
    this.translationArray = translate(navigator.language.substr(0, 2));

    let clientId = typeof(this.$route.query.client_id) !== "undefined" ? this.$route.query.client_id : null;
    if(clientId <= 8 || typeof(clientId) == 'undefined') {
        this.isSenzuApp = true;
    }

    window.addEventListener("resize", this.handleResize);
    this.handleResize();

    
    let scriptReader = document.createElement('script');
    scriptReader.setAttribute('src', 'static/html5-qrcode.js');
    document.head.appendChild(scriptReader);

    let _this = this;
    let intervalReader = setInterval(function() {
        try {
            _this.qrCodeReader = new Html5Qrcode("reader", { fps: 10, qrbox: 150});
            this.readerLoaded = true;
        } catch (e) {
            this.readerLoaded = false;
        }
        if(this.readerLoaded) {
            clearInterval(intervalReader);
        }
    }, 400);
  },
  data () {
    return {
        users: null,
        isSenzuApp: false,
        lastResult: null,
        clientId: this.$route.query.client_id,
        nameClient: localStorage.getItem("name_client"),
        urlImageClient: localStorage.getItem("url_image_client"),
        hasImageClient: localStorage.getItem("has_image_client"), 
        readerLoaded: false,
        intervalReader: null,
        qrCodeReader: null,
        errorModal: false,
        isDesktop: false,
        isMobile: true,
        qrActivated: false,
        valueBtn: "Activer la caméra",
        cameras: null,
        hasAvailableCamera: true,
        cameraId: null,
        selectCamera: null,
        cameraAlreadyUsed: false,
        translationArray: {},
        compatibility: true,
        idRecord: null,
        keyRecord: null,
        csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }
  },
  watch: {
      errorModal: function(value) {
        let _this = this;
        var timestamp = Date.now();
        window[timestamp] = setInterval(function() {
          _this.errorModal = false;
          clearInterval(window[timestamp]);
        }, 5400);
      },
      selectCamera: function(value) {
          if(this.cameraAlreadyUsed) {
              this.qrCodeReader.stop();
          }
          this.qrCodeReader.start({ deviceId: { exact: this.selectCamera} }, { fps: 10, qrbox: 150}, this.onScanSuccess);
          this.cameraAlreadyUsed = true;
      },
      qrActivated: function(value) {
          if(value) {
            if(this.cameraAlreadyUsed) {
                this.qrCodeReader.stop();
            }
            if(this.selectCamera !== null) {
                this.qrCodeReader.start({ deviceId: { exact: this.selectCamera} }, { fps: 10, qrbox: 150}, this.onScanSuccess);
            }            
          }
      },
      compatibility: function(value) {
          let _this = this;
          //Redirection vers Wallet
          this.$router.replace({name: 'Wallet', query: {
              id_record: this.idRecord,
              key: this.keyRecord,
              client_id: this.$route.query.client_id,
              redirect_uri: this.$route.query.redirect_uri,
              response_type: this.$route.query.response_type,
              scope: this.$route.query.scope,
              code_challenge: this.$route.query.code_challenge,
              code_challenge_method: this.$route.query.code_challenge_method,
              state: this.$route.query.state,
            }
          });
          var interval = setInterval(function() {
              _this.compatibility = true;
              clearInterval(interval);
          }, 5400);
      },
  },
  methods: {
    getMedia: async function (constraints) {
        let stream = null;
        let devices = null;
        try {
            await navigator.mediaDevices.getUserMedia({video: true});
            devices = await navigator.mediaDevices.enumerateDevices();

            let backCamera = [];
            let availableCamera = [];
            for(const key in devices) {
                if(devices[key].kind === "videoinput") {
                    availableCamera.push(devices[key]);
                }
                if(devices[key].label.match(/back/)) {
                    backCamera.push(devices[key]);
                }
            }

            if(backCamera.length === 1) {
                this.hasAvailableCamera = false;
                this.cameraId = backCamera[0].deviceId;
                this.cameras = availableCamera;
            } else {
                this.hasAvailableCamera = false;
                if(backCamera.length === 0) {
                    this.cameras = availableCamera;
                } else {
                    this.cameras = backCamera;
                }               
            }

            if(this.cameraId !== null) {
                this.qrCodeReader.start({ deviceId: { exact: this.cameraId} }, { fps: 10, qrbox: 150}, this.onScanSuccess);
                this.cameraAlreadyUsed = true;
            }
        } catch(err) {
            /* handle the error */
        }
    },
    activateQr: function() {
        if(!this.qrActivated) {
            this.getMedia({audio: false, video: true});
            
            this.valueBtn = "Arrêter la caméra";
        } else {
            this.qrCodeReader.stop();
            this.hasAvailableCamera = true;
            this.valueBtn = "Activer la caméra";
            this.cameraAlreadyUsed = false;
        }
        this.qrActivated = !this.qrActivated;
    },
    handleResize: function() {
      if(window.innerWidth <= 1120) {
          this.isMobile = true;
          this.isDesktop = false;
      } else {
          this.isMobile = false;
          this.isDesktop = true;
      }
    },
    historyBack: function() {
        this.$router.replace({name: "Authorize", query: 
            {
                client_id: this.$route.query.client_id, 
                redirect_uri: this.$route.query.redirect_uri,
                response_type: this.$route.query.response_type,
                scope: this.$route.query.scope,
                code_challenge: this.$route.query.code_challenge,
                code_challenge_method: this.$route.query.code_challenge_method,
                state: this.$route.query.state,
            }
        });
    },
    onScanSuccess: function(qrCodeMessage) {
        if(qrCodeMessage !== this.lastResult) {
            this.lastResult = qrCodeMessage;
            let match = qrCodeMessage.match('https:\/\/play.senzu.app\/[0-9]*@[a-zA-Z0-9]*');
            if(typeof(match[0]) != 'undefined') {
                let value = qrCodeMessage.match('[0-9]*@.*');
                value = value[0].split('@');
                let idRecord = value[0];
                let keyRecord = value[1];

                this.idRecord = value[0];
                this.keyRecord = value[1];
                
                fetch(`${this.$origin}/record-allowed?id_record=${idRecord}&key=${keyRecord}&client_id=${this.clientId}`, {
                    method: "GET",
                    headers: {
                        'Content-Type': 'application/json',
                        'CSRF-Token': this.csrfToken
                    },
                })
                .then(result => result.json())
                .then(data => {
                    if(data.error == 200) {
                        fetch(`${this.$origin}/nfc/users?id_record=${idRecord}&key=${keyRecord}&client_id=${this.clientId}`, {
                            method: "GET",
                            headers: {
                                'Content-Type': 'application/json',
                                'CSRF-Token': this.csrfToken
                            },
                        })
                        .then(result => result.json())
                        .then(data => {
                            if(data.error === 200) {
                                this.qrCodeReader.stop();
                                this.qrCodeReader.clear();
                                this.users = data.result;
                                localStorage.setItem("last_page", "QrCode");

                                if(this.users.length === 1) {
                                    //Redirect to Ask Pin
                                    this.$router.replace({name: 'AskPin', query: 
                                        {
                                            id_user: this.users[0].id, 
                                            id_record: idRecord, 
                                            key: keyRecord,
                                            client_id: this.clientId, 
                                            redirect_uri: this.$route.query.redirect_uri,
                                            response_type: this.$route.query.response_type,
                                            scope: this.$route.query.scope,
                                            code_challenge: this.$route.query.code_challenge,
                                            code_challenge_method: this.$route.query.code_challenge_method,
                                            state: this.$route.query.state,
                                        }
                                    });
                                } else {
                                    //redirect to ChooseUsers
                                    this.$router.replace({name: 'ChooseUsers', query: 
                                        {
                                            id_record: idRecord, 
                                            key: keyRecord, 
                                            client_id: this.clientId, 
                                            redirect_uri: this.$route.query.redirect_uri,
                                            response_type: this.$route.query.response_type,
                                            scope: this.$route.query.scope,
                                            code_challenge: this.$route.query.code_challenge,
                                            code_challenge_method: this.$route.query.code_challenge_method,
                                            state: this.$route.query.state,
                                        }
                                    });
                                }
                            } else {
                                this.errorModal = true;
                            }
                        });
                    } else {
                        if(data.status === -1) {
                            localStorage.setItem("reference", data.reference); 
                            localStorage.setItem("wallet_status", data.status);                   
                        } else {
                            localStorage.setItem("wallet_status", data.status);
                        }                                  
                        this.callOnGoing = false;
                        this.compatibility = false;
                    }
                });
            }
        }
    }
  }
}
</script>

<style scoped>
select {
    margin-bottom: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/QrCode.vue